export type ViewMode = 'simple' | 'advanced'

const STORAGE_KEY = 'sezi.viewMode'

export function readStoredMode(): ViewMode | null {
  if (typeof window === 'undefined') return null
  try {
    const v = window.localStorage.getItem(STORAGE_KEY)
    if (v === 'simple' || v === 'advanced') return v
  } catch {
    // localStorage may be unavailable (private mode, sandboxed).
  }
  return null
}

export function writeStoredMode(mode: ViewMode): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(STORAGE_KEY, mode)
  } catch {
    // ignore — best-effort persistence.
  }
}
